import React from "react";
import PropTypes from "prop-types";
import MiniBoard from "components/vmisc/flow_preview/MiniBoard";
import "styles/css/vmisc/Templates.css"


const TemplatesView = ({ flows, categories, filters, selectedFlow, onSelectFlow, onClickCategory, onClickUnselectFlow }) => (
  <div className="row h-100 w-100">
    <div className="col-md-3">
      <div className='nav-icons-categories'>
        <ul class="nav flex-column">
          {categories.map((category, idx) => (
            <li class="nav-item" key={idx}>
              <a class={`nav-link icon-category ${filters?.selectedCategory == category.id ? "active" : ""}`}
                onClick={() => onClickCategory(category.id)}>
                <i class={`${category.ui_settings?.display?.icon} nav-icon mr-1`}></i> {category.ui_settings?.display?.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="col-md-9">
      <div className="row template-list">
        {flows.map((flow) => (
          <div className="col-md-6 mb-4" key={flow.id}>
            <div className={`card card-body p-2 template-card ${selectedFlow == flow.id ? "selected" : ""}`} onClick={() => onSelectFlow(flow.id)}
              style={{ height: "300px", width: "100%" }}
            >
              <MiniBoard
                flowId={flow.id}
              />
              {selectedFlow == flow.id && (
                <div className='fas fa-times unselect-icon' onClick={(event) => onClickUnselectFlow(event)}></div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

TemplatesView.propTypes = {};

export default TemplatesView;